var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg8DSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13186",
    "data-name": "Rectangle 13186",
    width: 60,
    height: 60,
    transform: "translate(1851 1245.325)",
    fill: "#0068b3",
    stroke: "#89949b",
    strokeWidth: 1,
    opacity: 0.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1484",
    "data-name": "Mask Group 1484",
    transform: "translate(-1851 -1245.325)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(1856.156 1245.325)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13185",
    "data-name": "Rectangle 13185",
    width: 45,
    height: 55,
    rx: 6,
    transform: "translate(2.344 1.687)",
    fill: "#0055be"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14926",
    "data-name": "Group 14926",
    transform: "translate(2.227 2.344)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21870",
    "data-name": "Path 21870",
    d: "M10.1,44.536V12.651A11.7,11.7,0,0,1,21.787.937H14.672A11.719,11.719,0,0,0,2.953,12.656V44.531A11.719,11.719,0,0,0,14.672,56.25h7.115A11.7,11.7,0,0,1,10.1,44.536Z",
    transform: "translate(-2.953 -0.937)",
    fill: "#0055be"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14927",
    "data-name": "Group 14927",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21871",
    "data-name": "Path 21871",
    d: "M37.69,60H16.123A14.076,14.076,0,0,1,2.063,45.94V14.06A14.076,14.076,0,0,1,16.123,0H37.69A14.076,14.076,0,0,1,51.75,14.06V45.94A14.076,14.076,0,0,1,37.69,60ZM16.123,4.687A9.383,9.383,0,0,0,6.75,14.06V45.94a9.383,9.383,0,0,0,9.373,9.373H37.69a9.383,9.383,0,0,0,9.373-9.373V14.06A9.383,9.383,0,0,0,37.69,4.688Z",
    transform: "translate(-2.063 0)",
    fill: "#0055be"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14928",
    "data-name": "Group 14928",
    transform: "translate(25.664 9.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21872",
    "data-name": "Path 21872",
    d: "M24.516,18.281H20.531a8.212,8.212,0,0,1-8.2-8.2V6.094a2.344,2.344,0,1,1,4.687,0v3.984a3.52,3.52,0,0,0,3.516,3.516h3.984a2.344,2.344,0,1,1,0,4.687Z",
    transform: "translate(-12.328 -3.75)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14932",
    "data-name": "Group 14932",
    transform: "translate(13.477 21.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14929",
    "data-name": "Group 14929",
    transform: "translate(0.352)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_737",
    "data-name": "Ellipse 737",
    cx: 2.93,
    cy: 2.93,
    r: 2.93,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14930",
    "data-name": "Group 14930",
    transform: "translate(0 19.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21873",
    "data-name": "Path 21873",
    d: "M25.969,21.328H9.8a2.344,2.344,0,1,1,0-4.687H25.969a2.344,2.344,0,1,1,0,4.688Z",
    transform: "translate(-7.453 -16.641)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14931",
    "data-name": "Group 14931",
    transform: "translate(0 10.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21874",
    "data-name": "Path 21874",
    d: "M25.969,17.719H9.8a2.344,2.344,0,1,1,0-4.687H25.969a2.344,2.344,0,1,1,0,4.688Z",
    transform: "translate(-7.453 -13.031)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8DSelected);
export default __webpack_public_path__ + "static/media/8D_selected.78f447f8b1cbb3e1987a7c5f8e9181fd.svg";
export { ForwardRef as ReactComponent };